import React from 'react';
import { ImageCropperModifier } from '../../../components/molecules/ImageCropper/ImageCropper.modifier';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { useFormContext } from '../../../components/molecules/Form';
import { ValidSelectedImage } from '../../FileUpload/utils/validateImage';
import { Modifier } from '../../../lib/bemUtils/Modifier';
import IForm from '../../../types/IForm';
import { ImageContainer } from './ImageContainer';
import { LazyImageCropper } from '../../../components/molecules/ImageCropper/LazyImageCropper';
import { AspectRatioOption } from './ImageUploadForm';

export function getImageFromForm(form: IForm) {
  return form.params?.find(p => p.name === 'imageuploadparams')?.params?.find(p => p.name === 'image')?.value;
}

type PreviewWithCropperProps = {
  selectedPreview: ValidSelectedImage | undefined;

  viewportSwitch?: boolean;
  imageCropperModifier?: Modifier<ImageCropperModifier>;
  fixedAspectRatio?: AspectRatioOption;
  validationCallback?: (img: HTMLImageElement) => string[];
};

function toCroppieAspectRatio(ratio?: AspectRatioOption) {
  if (!ratio) {
    return ratio;
  }
  const orientation = ratio.numerator >= ratio.denominator ? 'landscape' : 'portrait';
  return { [orientation]: ratio };
}

export function PreviewWithCropper({
  selectedPreview,
  imageCropperModifier,
  viewportSwitch = false,
  fixedAspectRatio,
  validationCallback,
}: PreviewWithCropperProps) {
  const { t } = useSonTranslation('ImageUpload');
  const { inputs } = useFormContext();
  const { imageuploadparams } = inputs as any;
  const { image } = imageuploadparams.params;

  return selectedPreview
    ? (
        <ImageContainer filename={selectedPreview.file.name}>
          <LazyImageCropper
            src={selectedPreview.image.src}
            showZoomer
            viewportSwitch={viewportSwitch}
            minimumCropWidth={image.constraints.minWidth}
            minimumCropHeight={image.constraints.minHeight}
            aspectRatio={toCroppieAspectRatio(fixedAspectRatio) || image.constraints.aspectRatio}
            registerSubmitAction={imageuploadparams.registerGetCropData}
            alt={t('previewImageCropper')}
            validationCallback={validationCallback || (() => [])}
            modifier={imageCropperModifier}
          />
        </ImageContainer>
      )
    : null;
}
